<template>
  <el-container id="scene">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-header style="margin:0;padding:0">
        <el-menu :default-active="paths" class="el-menu-demo" mode="horizontal"
                 background-color="#FFFFFF" active-text-color="#1250B4">
          <el-menu-item index="/home/scene/ble" @click.native.stop="handleSelectMenu('/home/scene/ble')">
            蓝牙场景
          </el-menu-item>
          <el-menu-item index="/home/scene/other" @click.native.stop="handleSelectMenu('/home/scene/other')">
            其他场景
          </el-menu-item>
        </el-menu>
      </el-header>
      <el-main style="background:#FFFFFF;padding:15px;width:100%">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <!--          <span v-if="!is_ble" style="margin-left:0;color: #ffffff; font-size: 13px">
                      <el-radio-group v-model="tab_xz" size="small" @change="onXz">
                        <el-radio-button label="手动触发"></el-radio-button>
                        <el-radio-button label="设备触发"></el-radio-button>
                      </el-radio-group>
                    </span>-->
          <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
                placeholder="输入场景名称查询"
                style="width:10vw;"
                prefix-icon="el-icon-search"
                clearable
                @change="getScene()"
                v-model="scan_name">
            </el-input>
          </span>
          <el-button v-if="!is_ble" @click="addScene" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:auto;margin-right:15px">
            新增场景
          </el-button>
        </div>
        <div class="grid-box" :style="divStyle">
          <div class="grid-item" v-for="(site,item) in sites" :style="{background:site.bj}">
            <div style="height:200px;width:100%;line-height:0.3;align-items:center;text-align:center">
              <p style="width:100%;height:10px;margin-top:25px;font-size:16px">{{ site.name }}</p>
              <!--              <p style="width:100%;height:26px;margin-bottom:6px;font-size:15px;color: #8E8E8E">-->
              <!--                {{ site.description }}-->
              <!--              </p>-->
              <p style="width:100%;height:30px;margin-bottom:6px;font-size:15px;color: #8E8E8E">
                {{ site.buildName }}/{{ site.floorName }}/{{ site.roomName }}
              </p>
              <el-button v-if="site.state==='执行'" @click="setAct(site.id,item)" type="primary" round
                         icon="el-icon-video-play" :loading="false"
                         style="font-size:18px;">{{ site.state }}
              </el-button>
              <el-button v-else @click="setAct(site.id,item)" type="primary" round icon="el-icon-video-play"
                         :loading="true" style="font-size:18px;">{{ site.state }}
              </el-button>
              <div
                  style="display:flex;height:140px;width:100%;line-height:0.3;align-items:center;justify-content:center;">
                <el-button v-if="is_ble" @click="info_dvc(site)" type="text" size="small"
                           style="color:#437FE4;font-size:20px;">详情
                </el-button>
                <el-button v-if="is_ble" @click="del_Scene(site)" type="text" size="small"
                           style="color:#72767b;font-size:20px;margin-left:25px">删除
                </el-button>
                <el-button v-if="!is_ble" @click="change_dvc(site)" type="text" size="small" icon="el-icon-edit"
                           style="color:#72767b;font-size:20px;"/>
                <el-button v-if="!is_ble" @click="del_Scene(site)" type="text" size="small" icon="el-icon-delete"
                           style="color:#72767b;font-size:20px;margin-left:25px"/>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
            style="height:80px;margin-right:1vw;margin-top:20px;padding:0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDelScene"
        width="30%">
      <span>确定删除该场景吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelScene = false">取 消</el-button>
        <el-button type="primary" @click=delScene()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"scene",
  data() {
    return {
      is_ble:false,
      isBle:"0",
      paths:"/home/scene/ble",
      h_text:"场景策略",
      li_h_text:[
        {"text":"节能策略","colour":"#B7B7B7","pages":""}
      ],
      sites:[], /*{'name': 2, 'description': 1, "bj": "#EDEDED"}*/
      divStyle:{
        marginLeft:'0',
        marginTop:'20px',
        maxHeight:window.innerHeight - 170
      },
      tab_xz:'手动触发',
      edi_pwr:[],
      li_pwr:[
        {
          value:'1',
          label:'打开'
        },
        {
          value:'2',
          label:'关闭'
        }
      ], /*角色列表*/
      li_Scene:[],
      scan_name:"",
      page:1,
      pageSize:10,
      total:0,
      maxHeight:window.innerHeight - 225,
      tabData:[],
      edi_status:"",
      li_status:[
        {
          value:'启用',
          label:'启用'
        },
        {
          value:'禁用',
          label:'禁用'
        }
      ],
      edi_wx:"",
      li_wx:[
        {
          value:'是',
          label:'是'
        },
        {
          value:'否',
          label:'否'
        }
      ],
      post_head:{},
      daiDelScene:false
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.paths = path;
      this.is_ble = path.includes("ble");
      if (this.is_ble) {
        localStorage.setItem("is_ble","1");
      } else {
        localStorage.setItem("is_ble","0");
      }
      this.getScene();
    },
    onXz() {
      console.log(this.tab_xz);
    },
    change_dvc(row) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/sceneSon',
        query:{
          key:'changeScene',
          id:row.id,
          name:row.name,
          devName:row.devName,
          description:row.description,
          roomId:row.roomId,
          floorId:row.floorId,
          buildId:row.buildId,
          roomName:row.roomName,
          floorName:row.floorName,
          buildName:row.buildName,
          sceneItem:row.sceneItem
        }
      });
    },
    info_dvc(row) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/sceneSon',
        query:{
          key:'infoScene',
          id:row.id,
          name:row.name,
          description:row.description,
          sceneItem:row.sceneItem,
          roomId:row.roomId,
          floorId:row.floorId,
          buildId:row.buildId,
          roomName:row.roomName,
          floorName:row.floorName,
          buildName:row.buildName
        }
      });
    },
    addScene() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/sceneSon',
        query:{key:'addScene'}
      });
    },
    setAct(id,item) {
      this.sites[item]["bj"] = "#EDEDED";
      this.sites[item]["state"] = "执行中";
      const params = {
        'sceneId':id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.sceneExecute,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("执行成功");
        this.sites[item]["bj"] = "#EEF4FF";
        this.sites[item]["state"] = "执行";
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("执行失败");
        }
        this.sites[item]["bj"] = "#EEF4FF";
        this.sites[item]["state"] = "执行";
      });
    },
    del_Scene(row) {
      this.id = row.id;
      this.daiDelScene = true;
    },
    delScene() {
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delScene,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelScene = false;
        this.getScene();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getScene();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getScene();
    },
    init_View() {
      let data = this.li_Scene;
      let li_d = [];
      let j = 1;
      for (let i = 0; i < data.length; i++) {
        let d = {
          item:j,
          id:data[i]['id'],
          name:data[i]['name'],
          devName:data[i]['devName'],
          state:"执行",
          description:data[i]['description'],
          roomId:data[i]['roomId'],
          sceneItem:data[i]['sceneItem'],
          bj:"#EEF4FF"
        };
        d['floorId'] = -1;
        d['buildId'] = -1;
        d['roomName'] = "";
        d['floorName'] = "";
        d['buildName'] = "";
        console.log(data[i]['room']);
        if (data[i]['room']) {
          d['roomName'] = data[i]['room']['name'];
          d['floorId'] = data[i]['room']['floorId'];
          if (data[i]['room']['floor']) {
            d['floorName'] = data[i]['room']['floor']['name'];
            d['buildId'] = data[i]['room']['floor']['buildingId'];
            if (data[i]['room']['floor']['building']) {
              d['buildName'] = data[i]['room']['floor']['building']['name'];
            }
          }
        }
        li_d.push(d);
        j += 1;
      }
      this.sites = li_d;
    },
    getScene() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'all':false,
        'isBle':this.is_ble,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.scan_name && this.scan_name.length > 0) {
        params["name"] = this.scan_name;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getSceneList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_Scene = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取场景信息失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.isBle = localStorage.getItem("isBle");
    if (this.isBle === "0") { //非蓝牙场景-显示初始页面
      this.is_ble = localStorage.getItem("is_ble") === "1";
    } else {
      this.is_ble = true;
    }
    if (this.is_ble) {
      this.paths = "/home/scene/ble";
    } else {
      this.paths = "/home/scene/other";
    }
    this.getScene();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    // fil_tabData() {
    //   return this.sites.filter(item => {
    //     return !(this.scan_name && !item.name.includes(this.scan_name));
    //   });
    // },
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#scene {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.grid-box { /*表格式布局*/
  display: grid;
  grid-template-columns: repeat(auto-fill, 180px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 15px; /*行列间距*/
  row-gap: 15px;
  /*grid-template-rows: repeat(auto-fill, 300px); !*设置高度限制*!*/
}

.grid-item {
  border-radius: 8px 8px 8px 8px; /* 左上角、右上角、右下角、左下角 */
  background: linear-gradient(to bottom, #ffffff, #f2f2f2 50%, #d9d9d9 100%);
  box-shadow: 0 1px 6px #1D66DD, 0 0 10px rgba(0, 0, 0, 0.1) inset;
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/scene/scene.vue